import LoginHeader from './header'
import { Formik, Form } from 'formik'
import UseSendCode from './hooks/useSendCode'
import FormikInput from 'components/formikFields/input'
import { initialValues } from './utilities/initialValues'
import { LoginSchema } from './utilities/loginSchema'
import NextBtnIcon from '../../../assets/images/rectangle/next_button.svg'
import { toEnglishDigits } from 'utilities/helper/toEnglishNumber'
import { FormEvent, useState } from 'react'
const Login = () => {
    const [isSubmit, setIsSubmit] = useState<boolean>(false)
    const { mutate } = UseSendCode(setIsSubmit)
    const handleOnChange = (event: FormEvent) => {
        //@ts-ignore
        if (!isSubmit && event.target.value.length === 11) {
            mutate({
                //@ts-ignore
                phone_number: toEnglishDigits(event.target.value),
            })
            setIsSubmit(true)
        }
    }
    return (
        <>
            <div className="flex flex-col justify-between items-center h-screen relative ">
                <div className=" flex flex-col w-full">
                    <LoginHeader />
                    <Formik
                        initialValues={initialValues}
                        validationSchema={LoginSchema}
                        onSubmit={async (values) => {
                            if (!isSubmit) {
                                mutate({
                                    phone_number: toEnglishDigits(
                                        values.phoneNumber
                                    ),
                                })
                                setIsSubmit(true)
                            }
                        }}
                    >
                        {({ submitForm, values, handleChange }) => (
                            <Form onChange={handleOnChange}>
                                <div className=" mx-3 mt-3 text-sm font-normal">
                                    <FormikInput
                                        type="number"
                                        label="شماره موبایل"
                                        name="phoneNumber"
                                        placeholder="برای مثال: ۰۹۱۲۳۴۵۶۷۸۹"
                                        className="text-sm font-normal"
                                        min={0}
                                    />
                                </div>
                                <div className=" mt-4 text-center text-xs font-normal">
                                    <p>
                                        با ثبت‌نام و ورود به همیان،‌{' '}
                                        <a
                                            className=" text-blue-1 cursor-pointer"
                                            href="https://hamyanapp.com/policy/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            قوانین و مقررات
                                        </a>{' '}
                                        را می پذیرم.
                                    </p>
                                </div>
                                <div className="absolute bottom-5 right-5">
                                    <img
                                        src={NextBtnIcon}
                                        alt="nex-btn-icon"
                                        onClick={submitForm}
                                        className=" cursor-pointer"
                                    />
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </>
    )
}

export default Login
